import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  createAlertProtocol,
  deleteAlertProtocol,
  getAlertProtocols,
  updateAlertProtocol,
} from "app/services/alertProtocol/alertProtocol";
import { BASE_URL } from "static/constants";

export const alertProtocolApi = createApi({
  reducerPath: "alertProtocolApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["alertProtocol"],
  endpoints: (builder) => ({
    getAlertProtocols: builder.query({
      queryFn: (query) => {
        return { data: getAlertProtocols(query) };
      },
      providesTags: () => ["alertProtocol"],
    }),
    createAlertProtocol: builder.mutation({
      queryFn: (payload) => {
        return { data: createAlertProtocol(payload) };
      },
      invalidatesTags: ["alertProtocol"],
    }),
    updateAlertProtocol: builder.mutation({
      queryFn: (payload) => {
        return { data: updateAlertProtocol(payload) };
      },
      invalidatesTags: ["alertProtocol"],
    }),
    deleteAlertProtocol: builder.mutation({
      queryFn: (payload) => {
        return { data: deleteAlertProtocol(payload) };
      },
      invalidatesTags: ["alertProtocol"],
    }),
  }),
});

export const {
  useGetAlertProtocolsQuery,
  useCreateAlertProtocolMutation,
  useUpdateAlertProtocolMutation,
  useDeleteAlertProtocolMutation,
} = alertProtocolApi;
